import '../Vendors'; //global available Vendors

import './polyfills';
import { mx } from './globals';

import * as angular from 'angular';

import appModule from './app.module';

import '../DebugHelper/MxDebugHelper';

import(/* webpackChunkName: "shell" */ './index.scss');

document.execCommand('ClearAuthenticationCache', false);

// Entry point
angular.element(async function () {
	try {
		await mx.getConfigJson();
		angular.bootstrap(document.querySelector('html') as HTMLHtmlElement, [appModule]);
	} catch (e) {
		document.write(
			`<p style="color:red; display:flex; height:100%; justify-content:center; align-items:center; margin:0 40px; font-family:sans-serif; font-size:14px; font-weight:bold;">
				&#10006; Initialization Error
			</p>`
		);
	}
});
